import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import FlexBetweenRow from './FlexBetweenRow'
import HoverableTooltipRecommendation from './HoverableTooltipRecommendation'

interface Props {
  directOverlaps: number
  totalOverlaps: number
  teamOverlaps: number
  shifts?: number
  availableDays?: number
  showShifts?: boolean
}

const Separator = () => (
  <Box paddingTop="s4" paddingBottom="s4">
    <div style={{ width: '100%', height: 1, background: '#888' }} />
  </Box>
)

const WrapperSuggestionTooltip = ({
  directOverlaps,
  totalOverlaps,
  teamOverlaps,
  shifts = 0,
  availableDays,
  showShifts = true,
}: Props) => {
  const showAffecting =
    (shifts === 0 || directOverlaps === 0) && shifts !== null && shifts !== undefined
  return (
    <HoverableTooltipRecommendation
      label={i18n.t('time_off.approval_recommendation.other_validations')}
      title={i18n.t('time_off.approval_recommendation.other_validations')}
      count={0}
      showCount={false}
      details={
        <>
          <Box paddingTop="s6" />
          {showAffecting && (
            <>
              <Text.Normal color="grey000White" weight="semibold" size="200">
                {i18n.t('time_off.approval_recommendation.affecting_recommendation')}
              </Text.Normal>
              <Box paddingBottom="s6" />

              {directOverlaps === 0 && (
                <FlexBetweenRow>
                  <Text.Normal color="grey000White" size="200">
                    {i18n.t(
                      'time_off.approval_recommendation.affecting_recommendation_direct_reports'
                    )}
                  </Text.Normal>
                  <Text.Normal color="grey000White" size="200">
                    0
                  </Text.Normal>
                </FlexBetweenRow>
              )}
              {shifts === 0 && (
                <FlexBetweenRow>
                  <Text.Normal color="grey000White" size="200">
                    {i18n.t(
                      'time_off.approval_recommendation.affecting_recommendation_planned_shifts'
                    )}
                  </Text.Normal>
                  <Text.Normal color="grey000White" size="200">
                    0
                  </Text.Normal>
                </FlexBetweenRow>
              )}
              <Box paddingY="s6" />
              <Separator />
              <Box paddingY="s6" />
            </>
          )}
          <Text.Normal color="grey000White" weight="semibold" size="200">
            {i18n.t('time_off.approval_recommendation.additional_information')}
          </Text.Normal>
          <Box paddingBottom="s6" />

          <FlexBetweenRow>
            <Text.Normal color="grey000White" size="200">
              {i18n.t('time_off.approval_recommendation.total_reports')}
            </Text.Normal>
            <Text.Normal color="grey000White" size="200">
              {totalOverlaps}
            </Text.Normal>
          </FlexBetweenRow>
          <FlexBetweenRow>
            <Text.Normal color="grey000White" size="200">
              {i18n.t('time_off.approval_recommendation.team_overlaps')}
            </Text.Normal>
            <Text.Normal color="grey000White" size="200">
              {teamOverlaps}
            </Text.Normal>
          </FlexBetweenRow>
          {typeof availableDays === 'number' && (
            <FlexBetweenRow>
              <Text.Normal color="grey000White" size="200">
                {i18n.t('time_off.approval_recommendation.available_days')}
              </Text.Normal>
              <Text.Normal color="grey000White" size="200">
                {availableDays}
              </Text.Normal>
            </FlexBetweenRow>
          )}
        </>
      }
    />
  )
}

export default WrapperSuggestionTooltip
